var map = {
	"./localhost/clientSettings.json": 68,
	"./nikkaren.ra-abas.jp/clientSettings.json": 69,
	"./saison.ra-abas.jp/clientSettings.json": 70,
	"./sompo-direct.ra-abas.jp/clientSettings.json": 71,
	"./sompo-japan.ra-abas.jp/clientSettings.json": 72,
	"./template/clientSettings.json": 73,
	"./zenjikyo.ra-abas.jp/clientSettings.json": 74
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18;